import script from "./AccountsSearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountsSearchForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__